import * as Sentry from '@sentry/vue';

import { getLoginLink, getLogoutLink } from '@/utils/api/auth';
import { LOCAL_STORAGE_AUTH_ID } from '@/constants';
import { useAppStore } from '@/store/app';
import { getUriWithParam, uid } from '@/utils/helper';
import { gtmDirectToLogin } from '@/utils/helper/gtm';

export const login = async () => {
	gtmDirectToLogin();

	const appStore = useAppStore();
	try {
		const lang = appStore.getLanguage.value;
		const res = await getLoginLink(lang);
		if (!res?.loginLink) {
			return;
		}
		const loginUrl = getUriWithParam(res.loginLink, { lang: useLowerCase(lang) });
		if (loginUrl) {
			window.location.href = loginUrl;
		}
	} catch (error) {
		console.log({ error });
		Sentry.captureException(error);
	}
};
export const register = () => {
	login();
};

export const logout = async () => {
	try {
		const res = await getLogoutLink();
		if (res?.logoutLink) {
			const logoutUrl = res.logoutLink;
			if (logoutUrl) {
				window.location.href = logoutUrl;
			}
		}
	} catch (error) {
		console.log({ error });
		Sentry.captureException(error);
	}
};

export const getCurrentUserStore = () => {
	try {
		const authLs = localStorage.getItem(LOCAL_STORAGE_AUTH_ID) || '{}';
		const storageUser = JSON.parse(authLs);
		return storageUser;
	} catch (error) {
		Sentry.captureException(error);

		return {
			currentUser: {
				email: '',
				userId: '',
				country: '',
				avatar: '',
			},
			isLoggedIn: false,
			authToken: '',
		};
	}
};

export const clearUserStore = () => {
	try {
		const defaultStoreUser = {
			currentUser: {
				email: '',
				userId: '',
				country: '',
				avatar: '',
			},
			isLoggedIn: false,
			authToken: '',
		};
		localStorage.setItem(LOCAL_STORAGE_AUTH_ID, JSON.stringify(defaultStoreUser));
	} catch (error) {
		console.log({ error });
		Sentry.captureException(error);
	}
};

export const getTimezoneString = () => {
	const date = new Date();
	const utcOffset = -date.getTimezoneOffset() / 60;

	const minutes = -date.getTimezoneOffset() % 60;

	const utcString = `UTC${utcOffset >= 0 ? '+' : '-'}${padNumber(Math.abs(utcOffset))}:${padNumber(
		Math.abs(minutes),
	)}`;

	return utcString;
};

const padNumber = (number: number) => {
	return number.toString().padStart(2, '0');
};

let messageBoxId = '';

export const openMessageSessionInvalid = () => {
	const userStore = getCurrentUserStore();
	const isLoggedIn = !!userStore.isLoggedIn;
	if (!isLoggedIn) return;
	if (messageBoxId) return;

	const { $i18n } = useNuxtApp();

	messageBoxId = uid();
	ElMessageBox.alert($i18n.t('sessionTimeout'), '', {
		confirmButtonText: $i18n.t('login'),
		customClass: 'ev-confirmation-popup',
		showClose: false,
		autofocus: false,
		callback: async () => {
			messageBoxId = '';
			clearUserStore();
			login();
		},
	});
};
